import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import EditPanelForm from "../../../UI/Panels/Edit";
import { useParams } from "react-router-dom";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { CircularProgress, LinearProgress } from "@mui/material";
const EditPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_loginuser: "",
    smmpanel_loginusername: "",
    smmpanel_login_password: "",
    smmpanel_api_key: "",
    smmpanel_api_url: "",
    smmpanel_ticket_numper: "",
    smmpanel_date_of_ticket: null,
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skybe: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    customLogo: "",
    logo: null,
    smmpanel_notice: "",
    url_service: "",
    trust: 0,
    country_id: "",
    country_name: "",
    screenshot_urls: "",
    photos: "",
    type: "",
    reading_type: "HTML",
    logo_bg_color: "",
    currency: "",
    order: "",
  });
  const [payment_method, setPayment_method] = useState([]);

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Panels.GetOne}${id}`,
      });

      if (response) {
        setFormData({
          smmpanel_name: response?.data?.panel_details?.smmpanel_name || "",
          smmpanel_loginuser:
            response?.data?.panel_details?.smmpanel_loginuser || "",
          smmpanel_loginusername:
            response?.data?.panel_details?.smmpanel_loginusername || "",
          smmpanel_login_password:
            response?.data?.panel_details?.smmpanel_login_password || "",
          smmpanel_api_key:
            response?.data?.panel_details?.smmpanel_api_key || "",
          smmpanel_api_url:
            response?.data?.panel_details?.smmpanel_api_url || "",
          smmpanel_ticket_numper:
            response?.data?.panel_details?.smmpanel_ticket_numper || "",
          smmpanel_date_of_ticket:
            response?.data?.panel_details?.smmpanel_date_of_ticket || null,
          smmpanel_url: response?.data?.panel_details?.smmpanel_url || "",
          description: response?.data?.panel_details?.description || "",
          smmpanel_email: response?.data?.panel_details?.smmpanel_email || "",
          smmpanel_instagram:
            response?.data?.panel_details?.smmpanel_instagram || "",
          smmpanel_skybe: response?.data?.panel_details?.smmpanel_skybe || "",
          smmpanel_telegram:
            response?.data?.panel_details?.smmpanel_telegram || "",
          smmpanel_fb: response?.data?.panel_details?.smmpanel_fb || "",
          smmpanel_twitter:
            response?.data?.panel_details?.smmpanel_twitter || "",
          smmpanel_whatsapp:
            response?.data?.panel_details?.smmpanel_whatsapp || "",
          screenshot_urls: response?.data?.panel_details?.screenshot_urls || "",
          photos:
            response?.data?.panel_details?.screenshot_urls !== null &&
            response?.data?.panel_details?.screenshot_urls.length > 0
              ? []
              : response?.data?.panel_details?.photos || [],
          smmpanel_tel1: response?.data?.panel_details?.smmpanel_tel1 || "",
          customLogo: response?.data?.panel_details?.customLogo || "",
          logo: response?.data?.panel_details?.logo || "",
          smmpanel_notice: response?.data?.panel_details?.smmpanel_notice || "",
          url_service: response?.data?.panel_details?.url_service || "",
          trust: response?.data?.panel_details?.trust || "",
          currency: response?.data?.panel_details?.currency || "",
          country_id: response?.data?.panel_details?.country_id || "",
          country_name: response?.data?.panel_details?.country_name || "",
          type: response.data?.panel_details?.type || "",
          reading_type: response.data?.panel_details.reading_type || "HTML",
          logo_bg_color: response.data?.panel_details.logo_bg_color || "",
          order: response.data?.panel_details.order || null,
        });
        setPayment_method(
          response?.data?.payment_method?.length > 0
            ? response?.data?.payment_method?.map((method) => method.type)
            : []
        );
        await getCountries();
        await getCurrencies();
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCountries = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Countries.View,
      hasToken: true,
    });
    if (response) {
      setCountries(response);
    }
  };

  const getCurrencies = async () => {
    try {
      const response = await fetch("https://api.frankfurter.dev/v1/latest?base=usd");
      const data = await response.json();

      // Create a Set to avoid duplicates
      const allCurrencies = new Set([
        data.base,  // Add the base currency (USD)
        ...Object.keys(data.rates)  // Add all currency codes from rates
      ]);

      // Convert Set to array and sort alphabetically
      const sortedCurrencies = Array.from(allCurrencies).sort();

      setCurrencies(sortedCurrencies);
    } catch (error) {
      console.error("Error fetching currencies:", error);
      // Fallback to USD if API fails
      setCurrencies(["USD"]);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Panel <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Panel: {formData?.smmpanel_name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <EditPanelForm
              formData={formData}
              setFormData={setFormData}
              payment_method={payment_method}
              countries={countries}
              currencies={currencies}
            />
          )
        }
      />
    </div>
  );
};

export default React.memo(EditPanel);
